<script setup lang="ts">
import { KanbanStageHead } from '@shared/ui/kanban'

import { useTutorKanbanTable } from '../model/tutor-kanban-table.hook'
import TutorKanbanStage from './TutorKanbanStage.vue'
import TutorKanbanStageBody from './TutorKanbanStageBody.vue'

defineOptions({
  name: 'TutorKanbanTable',
})

const {
  refStages,
  getHref,
  getStageName,
  getStageColor,
} = useTutorKanbanTable()
</script>

<template>
  <div class="tkb-table">
    <TutorKanbanStage
      v-for="stage in refStages"
      :key="stage.name"
      :stage="stage.name"
    >
      <template #head>
        <KanbanStageHead
          :text="getStageName(stage.name)"
          :color="getStageColor(stage.name)"
          :card-count="stage.data.count"
          :href="getHref(stage.name)"
        />
      </template>
      <template #default>
        <TutorKanbanStageBody
          :tutors="stage.data.tutors"
        />
      </template>
    </TutorKanbanStage>
  </div>
</template>

<style scoped lang="scss" src="./TutorKanbanTable.scss" />
